// extracted by mini-css-extract-plugin
export default {"root":"Expandable_root__kFD-R","heading":"Expandable_heading__P2ayx","title":"Expandable_title__nEAyO","button":"Expandable_button__BWKJj"};